import { Component } from "@angular/core";
import { FormBuilder, FormGroup, FormArray, Validators } from "@angular/forms";
import { ModalController } from "ionic-angular";
import { NavController, NavParams, ToastController } from "ionic-angular";
import { Observable } from "rxjs/Observable";
import { HareComponent } from "../../components/harecomponent/harecomponent";
import { ListComponent } from "../../components/listcomponent/listcomponent";
import { Hareline } from "../../models/interfaces/hareline.model";
import { Guest_Fee } from "../../models/interfaces/guest.model";
import { Member } from "../../models/interfaces/member.model";
import { HarelinePage } from "../../pages/hareline/hareline";
import { Sh3Page } from "../../pages/sh3/sh3";
import { DbserviceProvider } from "../../providers/dbservice/dbservice";
import { ValidationserviceProvider } from "../../providers/dbservice/validationservice";
import { ConfigService } from '../../providers/dbservice/configservice';

@Component({
  selector: "page-hareline_add",
  templateUrl: "hareline_add.html",
})
export class HarelineAddPage {
  //private guestfees: Guest_Fee;
  //private gf [];
  private hareline$: Observable<Hareline[]>;
  private harelineForm: FormGroup;
  private hareline: Hareline;
  private member$: Observable<Member[]>;
  private member: Member;
  private hares: string;
  private scribe: string;
  private hl_id: number;
  private hl_datetime: Date;
  private hareM: Member[];
  private scribeM: Member[];
  private MaxYear = new Date(new Date());
  private MM = parseInt(this.MaxYear.toISOString().substring(0, 4)) + 2;
  private styleName: string ="";

  constructor(private configService: ConfigService,public navCtrl: NavController, public navParams: NavParams,
    private formBuilder: FormBuilder, private toastCtrl: ToastController,
    private db: DbserviceProvider, public modalCtrl: ModalController,
  ) {
    console.log("HarelineAddPage constructor");
    this.styleName=this.configService.getConfig("STYLENAME");
    this.harelineForm = this.formBuilder.group({
      "hl_comment": [""],
      "hl_datetime": ["", Validators.required],
      "hl_gps": [""],
      "guestfees": this.formBuilder.array([]),
      "hl_guestfee": [""],
      "hl_hare": [""],
      "hl_runno": ["", [Validators.min(1), Validators.max(9999)]],
      "hl_runsite": [""],
      "hl_runtype": [""],
      "hl_scribe": [""],
    });
    this.db.dbCol({
      "action": "select", "mapObject": "settings",
      "sqlExtended": " where se_class = 'Guest'"
    })
      .subscribe((defguestfee) => {
        //this.guestfees = defguestfee
        defguestfee.forEach(gf => {
          this.addGuestFee(gf);
        });
        this.harelineForm.controls.hl_guestfee.setValue(defguestfee[0].se_key_value);
      });
    this.db.dbCol({
      "action": "select", "mapObject": "vw_hareline_add",
    }).subscribe((rt) => {
      this.hl_datetime = rt[0].hl_datetime;
      this.harelineForm.controls.hl_datetime.setValue(this.hl_datetime);
      this.harelineForm.controls.hl_runno.setValue(rt[0].hl_runno);
    });

  }

  get guestfees(): FormArray {
    console.log("HarelineAddPage addGuestFee");
    return <FormArray>this.harelineForm.get('guestfees');
  }

  addGuestFee(guestfee: any) {
    console.log("HarelineAddPage addGuestFee");
    this.guestfees.push(this.createGuestFeeGroup(guestfee));
  }

  createGuestFeeGroup(guestfee: any): FormGroup {
    console.log("HarelineAddPage createGuestFeeGroup");
    return this.formBuilder.group({
      name: [guestfee.se_key_name, [Validators.required]],
      amount: [guestfee.se_key_value, [Validators.required]]
    })
  }


  private ionViewWillEnter() {
    console.log("HarelineAddPage ionViewWillEnter");
    this.onInitPage();
  }

  private onInitPage() {
    console.log("HarelineAddPage onInitPage");
    
  }

  private selectScribeList(val) {
    console.log("HarelineAddPage selectScribeList");
    let selection = this.modalCtrl.create(ListComponent, { "obs": "member", "sel": val, "type": "S" });

    selection.present();

    selection.onDidDismiss((data) => {
      if (data != null) {
        this.scribeM = data;
        this.scribe = data.map((v) => v.mb_hashname).toString();
      }
    });
  }

  private origselectHareList(val) {
    console.log("HarelineAddPage selectHareList");
    let selection = this.modalCtrl.create(ListComponent, { "obs": "member", "sel": val });
    selection.present();
    selection.onDidDismiss((data) => {
      if (data != null) {
        this.hareM = data;
        this.hares = data.map((v) => v.mb_hashname).toString();
      }
    });
  }

  private selectHareList(val) {
    console.log("HarelineAddPage selectHareList");
    let selection = this.modalCtrl.create(HareComponent, { "obs": "member", "sel": val });
    selection.present();
    selection.onDidDismiss((data) => {
      if (data != null) {
        this.hareM = data;
        this.hares = data.map((v) => v.mb_hashname).toString();
      }
    });
  }

  private goback() {
    console.log("HarelineAddPage goback");
    this.navCtrl.pop();
  }

  private addHareline(value: any) {
    console.log("HarelineAddPage addHareline");

    if (typeof this.harelineForm.controls.hl_gps.value != 'undefined' && this.harelineForm.controls.hl_gps.value) {
      this.harelineForm.controls.hl_gps.setValue(this.harelineForm.controls.hl_gps.value.replace(/[\])}[{(]/g, ''));
    }
      
    //this.db.dbCol({ "action": "insert", "mapObject": "hareline", ...this.harelineForm.value })
    this.db.dbCol({ "action": "insert", "mapObject": "hareline", 
     "hl_runno": this.harelineForm.controls.hl_runno.value , 
     "hl_datetime": this.harelineForm.controls.hl_datetime.value , 
     "hl_gps": this.harelineForm.controls.hl_gps.value,
     "hl_runsite": this.harelineForm.controls.hl_runsite.value,
     "hl_runtype": this.harelineForm.controls.hl_runtype.value,
     //"hl_guestfee": this.harelineForm.controls.hl_guestfee.value,
     "hl_comment": this.harelineForm.controls.hl_comment.value})
      .subscribe((ret) => {
        if (this.hareM !== undefined) {
          this.hareM.forEach((el) => {
            this.db.dbCol({ "action": "insert", "mapObject": "hareline_assistant", "mb_id": (el as any).mb_id, "hl_id": ret.id, "hs_type": "H" })
              .subscribe();
          });
        }
        if (this.scribeM !== undefined) {
          this.scribeM.forEach((el) => {
            this.db.dbCol({ "action": "insert", "mapObject": "hareline_assistant", "mb_id": (el as any).mb_id, "hl_id": ret.id, "hs_type": "S" })
              .subscribe();
          });
        }

        if (this.guestfees.value !== undefined) {
          this.guestfees.value.forEach((el) => {
            this.db.dbCol({ "action": "insert", "mapObject": "guest_fee",  "hl_id": ret.id, "gf_name": el.name, "gf_amount": el.amount })
              .subscribe();
          });
        }

        this.navCtrl.pop();
      });
  }

  private ngOnDestroy() {
    console.log("HarelineAddPage ngOnDestroy");
  }
}



// WEBPACK FOOTER //
// ./src/pages/hareline/hareline_add.ts